const info = {
  ZH: { //中文翻译
    announcement: '公告',
    massage: '为确保及时获取CAMDS系统更新信息及最新资讯，请核实个人信息',
    msg: '所有带(<span style="color: red;">*</span>)的字段都必须填写',
    userInfo: '用户信息：',
    orgName: '企业全称：',
    loginName: '用户名：',
    name: '姓名：',
    telephoneNo: '联系电话：',
    fax: '传真号码：',
    email: '电子邮箱：',
    comfirm: '确定',
    msg_telephoneNo: '请输入联系电话且只能为数字。',
    msg_fax: '请输入传真号码且只能为数字。',
    msg_email: '请输入电子邮箱地址（名字@域）.',
    msg_mainProduct: '请输入主营业务.',
    duns: 'DUNS（无税号时必填）',
    orgCode: '纳税人识别号（18位）',
    confirmMsg: '我确认以上信息正确',
    confirmMsg1: '纳税人识别号和邓白氏码请至少填写一个！',
    confirmMsgOrgCode: '纳税人识别号格式错误，请输入18位税号．且字符必须是数字0-9、小写字母 a-z或大写字母 A-Z的任意组合。',
    confirmMsgDuns: 'duns格式错误',
    confirmMsg2: '请确认信息是否正确，并在前面的□内打钩',
    mainProduct: '主营业务',
    homepage: '主页',
    msg_name: '请输入姓名'
  },
  EN: {
    announcement: 'Announcement',
    massage: 'To insure get the lastest news, please make sure your personal infomation.',
    msg: 'All marking(<span style="color: red;">*</span>)must be filled in',
    userInfo: 'UserInfo',
    orgName: 'OrgName：',
    loginName: 'loginName：',
    name: 'Name：',
    telephoneNo: 'Tel No：',
    fax: 'Fax No：',
    email: 'E-Mail：',
    comfirm: 'Confirm',
    msg_telephoneNo: 'numbers only when Tel No. filled in',
    msg_fax: 'numbers only when Fax No. filled in',
    msg_email: 'please fill email address(name@domain)',
    msg_mainProduct: 'Please input the main product.',
    duns: 'DUNS(Necessary if no Tax ID)',
    orgCode: 'Tax ID(18 characters)',
    confirmMsg: 'I confirm the above information is correct.',
    confirmMsg1: 'Please fill in the Dun & Bradstreet code!',
    confirmMsgOrgCode: 'Tax ID format error, Please enter an 18-digit tax identification number and the characters must be any combination of numbers 0-9, lowercase letters a-z, or uppercase letters A-Z.',
    confirmMsgDuns: 'duns  format error',
    confirmMsg2: 'Please confirm the information and check the box!',
    mainProduct: 'Main Product',
    homepage: 'homepage',
    msg_name: 'Please input the name'
  }
}

export default info //需要暴露出去
